/**
 * The $100 Marriage Reward is a limited campaign that runs until enough couples have shared
 * their testimonials. Set this to false to hide it across the site: the homepage section, the
 * announcement bar link, and the footer and policy links. The terms page stays reachable by URL
 * for couples who have already claimed.
 */
export const MARRIAGE_REWARD_ENABLED = true;

export const REWARD_TERMS_PATH = "/marriage-reward-terms";
